<template>
  <div>
    <div class="receipt-viewer el-image-viewer__canvas">
      <template v-if="!isSingle">
        <span
          class="el-image-viewer__btn el-image-viewer__prev receipt-prev"
          :class="{ 'is-disabled': !infinite && isFirst }"
          @click="prev"
        >
          <i class="el-icon-arrow-left" />
        </span>
        <span
          class="el-image-viewer__btn el-image-viewer__next receipt-next"
          :class="{ 'is-disabled': !infinite && isLast }"
          @click="next"
        >
          <i class="el-icon-arrow-right" />
        </span>
      </template>
      <div v-if="!isPdf" class="el-image-viewer__btn el-image-viewer__actions">
        <div class="el-image-viewer__actions__inner">
          <i class="el-icon-zoom-out" @click="handleActions('zoomOut')" />
          <i class="el-icon-zoom-in" @click="handleActions('zoomIn')" />
          <!-- <i class="el-image-viewer__actions__divider" />
          <i class="el-image-viewer__actions__divider" /> -->
          <i class="el-icon-refresh-left" @click="handleActions('anticlocelise')" />
          <i class="el-icon-refresh-right" @click="handleActions('clocelise')" />
        </div>
      </div>
      <template v-for="(url, i) in imageUrlList">
        <iframe
          v-if="isPdf && i === index"
          :key="url"
          class="pdf"
          :src="currentImg"
          frameborder="0"
        />
        <img
          v-else-if="i === index"
          ref="img"
          :key="url"
          class="el-image-viewer__img"
          :src="`${currentImg}?token=${token}`"
          :style="imgStyle"
          @mousedown="handleMouseDown"
        >
      </template>
    </div>
  </div>
</template>

<script>
import { on, off } from 'element-ui/src/utils/dom';
import { rafThrottle } from 'element-ui/src/utils/util';
import { getToken } from "@/utils/auth";

const Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen',
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original',
  },
};

export default {
  name: 'ReceiptImage',
  props: {
    urlList: {
      type: Array,
      default: () => [],
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      index: this.initialIndex,
      mode: Mode.CONTAIN,
      infinite: true,
      // loading: false,
      dragHandler: undefined,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false,
      },
      token: '',
      imageUrlList: [],
      // isPdf: false, // 是否pdf
    };
  },
  computed: {
    isSingle() {
      return this.urlList.length <= 1;
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.urlList.length - 1;
    },
    imgStyle() {
      const {
        scale, deg, offsetX, offsetY, enableTransition,
      } = this.transform;
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`,
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = '100%';
        style.maxHeight = '100%';
      }
      return style;
    },
    currentImg() {
      return this.urlList[this.index];
    },
    isPdf() {
      return this.urlList[this.index].endsWith('.pdf')
    }
  },
  watch: {
    urlList: {
      handler(val){
        this.imageUrlList = val
        this.index = 0
      },
      immediate: true,
  }
  },
  created() {
    this.token = getToken().replace('Bearer ', '')
  },
  methods: {
    prev() {
      if (this.isFirst && !this.infinite) return;
      const len = this.urlList.length;
      this.index = (this.index - 1 + len) % len;
    },
    next() {
      if (this.isLast && !this.infinite) return;
      const len = this.urlList.length;
      this.index = (this.index + 1) % len;
    },
    handleMouseDown(e) {
      // if (this.loading || e.button !== 0) return;

      const { offsetX, offsetY } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this.dragHandler = rafThrottle((ev) => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
      });
      on(document, 'mousemove', this.dragHandler);
      on(document, 'mouseup', () => {
        off(document, 'mousemove', this.dragHandler);
      });

      e.preventDefault();
    },
    handleActions(action, options = {}) {
      // if (this.loading) return;
      const { zoomRate, rotateDeg, enableTransition } = {
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true,
        ...options,
      };
      const { transform } = this;
      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
        default:
          break;
      }
      transform.enableTransition = enableTransition;
    },
  },
};
</script>

<style lang="less" scoped>
.pdf {
  overflow-y: auto;
  width: 100%;
  height: 100%;
}
.receipt-viewer {
  position: relative;
  overflow: hidden;
  .receipt-prev {
    left: 10px;

  }
  .receipt-next {
    right: 10px;
  }
}
</style>
